import templateHtml from './reset-password-modal.html';

const component = {};

component.template = templateHtml;

component.bindings = {
    isModalVisible: '=',
    isHaveIBeenPwnedServiceEnabled: '<'
};

component.controllerAs = 'vm';

function ResetPasswordModalController(
    SettingsApi,
    $q,
    Page,
    BdLocalize,
    Notify,
    $window,
    Settings,
    ApiError,
    HTTP_STATUS_CODES,
    $state,
    ALERT_TYPE
) {
    const vm = this;
    vm.ALERT_TYPE = ALERT_TYPE;
    vm.BdLocalize = BdLocalize;

    vm.closeModal = function closeModal() {
        vm.currentPassword = null;
        vm.newPassword = null;
        vm.confirmPassword = null;
        vm.isPasswordStrongEnough = false;
        vm.isModalVisible = false;
    };

    vm.currentPassword = null;
    vm.newPassword = null;
    vm.confirmPassword = null;
    vm.isPasswordStrongEnough = false;
    vm.isBuildiumAdmin = Settings.IsBuildiumAdminUser;
    vm.haveIBeenPwned = false;
    vm.validationErrorMessage = null;
    vm.passwordMatchValidationMessage = BdLocalize.getString('Global.Component.Settings.Security.Password.ResetPasswordModal.PasswordsMustMatch', 'Password fields must match');
    vm.passwordChanged = false;

    vm.passwordChangedConfirmation = function passwordChangedConfirmation() {
        $state.go('settings.managerMySettings.security');
        vm.closeModal();
    };

    vm.submitResetPassword = function submitResetPassword() {
        vm.haveIBeenPwned = false;
        vm.validationErrorMessage = null;

        const passwordUpdateDTO = {
            NewPassword: vm.newPassword,
            CurrentPassword: vm.currentPassword
        };

        return SettingsApi.savePassword(passwordUpdateDTO)
            .then(function onSave() {
                vm.passwordChanged = true;
            })
            .catch(function onResponseError(response) {
                return vm.handleError(response);
            });
    };

    vm.handleError = function handleError(response) {
        if (response && response.status === HTTP_STATUS_CODES.BadRequest) {
            Notify.error(ApiError.getBadRequestMessage(response));
            $state.go('settings.managerMySettings.security');
            Page.scrollToTop();
            return $q.reject(response);
        } else if (response && response.data !== null) {
            if (response.data.ErrorCode === '208') {
                vm.haveIBeenPwned = true;
                vm.validationErrorMessage = BdLocalize.getString('Global.Component.Settings.Security.Password.ResetPasswordModal.HaveIBeenPwnedErrorMessage',
                    'This password meets our requirements but it is on a list of commonly-guessed passwords. Please choose a different password.');
                return $q.reject(response);
            }
        }
        return ApiError.notify(response);
    };

    vm.passwordStrengthChange = function passwordStrengthChange(isPasswordStrongEnough) {
        vm.isPasswordStrongEnough = isPasswordStrongEnough;
    };
}

ResetPasswordModalController.$inject = [
    'SettingsApi',
    '$q',
    'Page',
    'BdLocalize',
    'Notify',
    '$window',
    'Settings',
    'ApiError',
    'HTTP_STATUS_CODES',
    '$state',
    'ALERT_TYPE'
];
component.controller = ResetPasswordModalController;
export const ResetPasswordModalComponent = component;
